import { NotificationsProvider } from "@mantine/notifications";
import 'dayjs/locale/pt-br';
import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { AppProvider } from "./contexts/app.context";
import { AuthProvider } from "./contexts/auth.context";
import { RequireAuth } from "./utility/requireAuth";
import routes from "./utility/routes";
import { Container, Group, Paper, Text } from "@mantine/core";
import { FaWrench } from "react-icons/fa";


function App() {
  return <>
    <NotificationsProvider>
    <BrowserRouter>
      {/* <MaintenancePage /> */}
      <AuthProvider>
      <AppProvider>
        <Routes>
          {routes.filter(r => !r.private).map(r => <Route path={r.url} element={r.component} />)}
          <Route element={<RequireAuth />}>
            {routes.filter(r => r.private).map(r => <Route path={r.url} element={r.component} />)}
          </Route>
        </Routes>
      </AppProvider>
      </AuthProvider>
    </BrowserRouter>
    </NotificationsProvider>
  </>
}

export default App;

function MaintenancePage() {
  return (
    <Container size="xs" style={{ marginTop: '100px' }}>
      <Paper p="lg" style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
        <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center'}}>
          <img alt="DMOC" src={`/assets/dmoc/5.png`} style={{height: 40}} />
        </div>
        <Group mt="lg">
          <FaWrench size={24} color="#0995d8" />
          <Text size="xl" weight={700} color="#0995d8">
            Estamos em manutenção temporariamente
          </Text>
        </Group>
      </Paper>
    </Container>
  );
}